import apiClient, { extractData } from '../api-client';

export const ghnApi = {
  // Shops CRUD
  listShops() {
    return apiClient.get('/ghn/shops').then(extractData);
  },
  createShop(data) {
    return apiClient.post('/ghn/shops', data).then(extractData);
  },
  updateShop(id, data) {
    return apiClient.put(`/ghn/shops/${id}`, data).then(extractData);
  },
  deleteShop(id) {
    return apiClient.delete(`/ghn/shops/${id}`);
  },
  setDefaultShop(id) {
    return apiClient.post(`/ghn/shops/${id}/set-default`).then(extractData);
  },

  // Address cache
  getProvinces() {
    return apiClient.get('/ghn/provinces').then(extractData);
  },
  getDistricts(provinceId) {
    return apiClient.get('/ghn/districts', { params: { province_id: provinceId } }).then(extractData);
  },
  getWards(districtId) {
    return apiClient.get('/ghn/wards', { params: { district_id: districtId } }).then(extractData);
  },

  // Available services for a route
  getAvailableServices(toDistrictId, shopId = null) {
    const params = { to_district_id: toDistrictId };
    if (shopId) params.shop_id = shopId;
    return apiClient.get('/ghn/available-services', { params }).then(extractData);
  },

  // Address parsing
  parseAddress(address) {
    return apiClient.post('/ghn/parse-address', { address }).then(extractData);
  },

  // Fee calculation
  calculateFee(data) {
    return apiClient.post('/ghn/calculate-fee', data).then(extractData);
  },

  // Kéo toàn bộ kho từ GHN về (dùng key GHN đã nhập ở trang Đơn vị vận chuyển)
  importShops() {
    return apiClient.post('/ghn/import-shops').then(extractData);
  },

  // Sync
  syncMasterData(shopId = null) {
    const params = shopId ? { shop_id: shopId } : {};
    return apiClient.post('/ghn/sync-master-data', null, { params }).then(extractData);
  },
  getSyncStatus() {
    return apiClient.get('/ghn/sync-status').then(extractData);
  },

  printLabel(orderCodes, shopId = null) {
    const body = { order_codes: orderCodes };
    if (shopId) body.shop_id = shopId;
    return apiClient.post('/ghn/print-label', body, { responseType: 'text' }).then(res => res.data);
  },
};
